import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Col, Row, Spinner } from 'react-bootstrap';

import useSmallScreen from '../../../lib/hooks/useSmallScreen';
import { WanConnections } from '../../../lib/utils/helpers';
import WanConnectionBox from '../WanConnectionBox';

import { validSlotKeys, validSlotStates } from './cell-settings-shared';
import SimCards from './SimCards';

const CellSettings = ({
  cellStatus,
  readOnly = false,
  slotStatus,
  onCellOnOff,
  onSlotUpdate,
  onSlotSelectAndReboot,
  onSlotSelectAndPowerOff,
  loading = false,
  signalStrengthNormalized,
  operatorName,
  dataCapability,
  attachedSlotName,
  connectionStatus,
}) => {
  const isSmallScreen = useSmallScreen();
  return (
    <Row>
      {loading && (
        <Col sm={12}>
          <Alert variant="info">
            <Spinner animation="border" size="sm" /> Please wait, while we are
            processing...
          </Alert>
        </Col>
      )}
      <Col xl={4}>
        <WanConnectionBox
          active={cellStatus}
          type="cell"
          networkName={attachedSlotName || ''}
          onStatusChange={onCellOnOff}
          loading={loading}
          readOnly={readOnly}
          signalStrength={signalStrengthNormalized}
          operatorName={operatorName}
          dataCapability={dataCapability}
          connectionStatus={connectionStatus}
        />
      </Col>
      <Col
        xl={8}
        className={classNames('mt-md-5', {
          'mt-3': isSmallScreen,
          'align-items-lg-center d-flex justify-content-center':
            !cellStatus || slotStatus.length === 0,
        })}
      >
        {cellStatus ? (
          <SimCards
            readOnly={readOnly}
            slotStatus={slotStatus}
            onSlotUpdate={onSlotUpdate}
            onSlotSelectAndReboot={onSlotSelectAndReboot}
            onSlotSelectAndPowerOff={onSlotSelectAndPowerOff}
          />
        ) : (
          <strong>Please turn ON cell to view available SIM Cards.</strong>
        )}
      </Col>
    </Row>
  );
};

CellSettings.propTypes = {
  cellStatus: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  signalStrengthNormalized: PropTypes.number,
  operatorName: PropTypes.string,
  dataCapability: PropTypes.string,
  attachedSlotName: PropTypes.string,
  slotStatus: PropTypes.arrayOf(
    PropTypes.shape({
      slotName: PropTypes.string.isRequired,
      slotState: PropTypes.oneOf(validSlotStates).isRequired,
      selected: PropTypes.bool,
      slotConfig: PropTypes.shape({
        cardName: PropTypes.string,
        apn: PropTypes.string,
        slotKey: PropTypes.oneOf(validSlotKeys).isRequired,
        isFixed: PropTypes.bool,
      }).isRequired,
      imsi: PropTypes.string,
      iccid: PropTypes.string,
      homeNetwork: PropTypes.string,
    }).isRequired,
  ).isRequired,
  connectionStatus: PropTypes.oneOf(['', ...WanConnections]),
  onCellOnOff: PropTypes.func.isRequired,
  onSlotUpdate: PropTypes.func.isRequired,
  onSlotSelectAndReboot: PropTypes.func.isRequired,
  onSlotSelectAndPowerOff: PropTypes.func.isRequired,
};

export default CellSettings;
